export default {"src":"/_next/static/media/partner46.03b76478.svg","height":78,"width":250,"blurWidth":0,"blurHeight":0};